import React from 'react';
import clsx from 'clsx';
import { Box, Stack } from '@mui/material';
import { PaginationProps } from '../../types';
import { useStyles } from './styles';

export const Pagination: React.FC<PaginationProps> = ({ index, total, onIndexPress }) => {
  const styles = useStyles();

  return (
    <Stack className={styles.container} direction="row" spacing={0.5}>
      {Array.from({ length: total }).map((_, i) => {
        const isActive = i === index;
        return (
          <Box key={i} sx={{ flex: 1 }} className={styles.paginationItemContainer} onClick={() => onIndexPress(i)}>
            <Box className={clsx(styles.paginationItemInactive, isActive && styles.paginationItemActive)} />
          </Box>
        );
      })}
    </Stack>
  );
};
